module.exports = __webpack_public_path__ + "img/icon_1_color@3x.97920f22.png";